import axios from 'axios';
import { useEffect, useState } from 'react';
import { CAMPAIGNS_NAMES, GET_ALL_FUNDRAISING } from '../constants/endpoints';

export function useGetFundraising(props) {
    const [fundraisingSettings, setFundraisingSettings] = useState({});
    
    useEffect(() => {
        getFundraisingSettings();
    },[]);

    const getFundraisingSettings = () => {
        axios.get(GET_ALL_FUNDRAISING)
        .then((res) => {
            if(res?.data?.status){
              setFundraisingSettings(res?.data?.response);
            }
        }).catch((error) => {
  
        })
    }

    return { fundraisingSettings, getFundraisingSettings };
};